import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { useSelector, useDispatch } from 'react-redux';

import useCheckStoreOpen from '~hooks/useCheckStoreOpen';
import { DATA_TEST_ID } from '~constants/tests';
import LottieIcon from '~components/LottieIcon';
import { MODALS } from '~redux/Modal/constants';
import CustomModal from '~components/CustomModal';
import SearchStoreActions from '~redux/SearchStore/actions';
import { DISPATCH_METHOD_TARGET } from '~redux/SearchStore/constants';
import { DISPATCH_METHODS } from '~constants/address';
import ModalActions from '~redux/Modal/actions';
import { SUBSCRIPTION_STATUS, isAccountStatusSuspended } from '~constants/subscription';

import styles from './styles.module.scss';
import Message from './Message';

const ClosedStoreModal = () => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.modal[`${MODALS.STORE_CLOSED}ModalIsOpen`]);
  const { currentSubsidiary } = useSelector((state) => state.searchStore);
  const currentDispatchMethod = useSelector((state) => state.searchStore[DISPATCH_METHOD_TARGET]);
  const subscriptionStatus = useSelector(
    (state) => state.core.settings.subscriptionStatus || SUBSCRIPTION_STATUS.ACTIVE
  );

  const { closedByAttribute, deliveryOpen, pickUpOpen } = useCheckStoreOpen();
  const onlyDeliveryAvailable = deliveryOpen && !pickUpOpen;
  const onlyPickupAvailable = pickUpOpen && !deliveryOpen;

  const continueWith = () => {
    dispatch(
      SearchStoreActions.getStoreData(
        currentSubsidiary.id,
        onlyDeliveryAvailable ? DISPATCH_METHODS.DELIVERY : DISPATCH_METHODS.PICKUP
      )
    );
    dispatch(ModalActions.closeModal(MODALS.STORE_CLOSED));
  };

  const configModalMessage = [
    [() => isAccountStatusSuspended(subscriptionStatus), 'titleStoreClosed'],
    [() => onlyPickupAvailable, 'titleStoreClosedDelivery'],
    [() => onlyDeliveryAvailable, 'titleStoreClosedPickup'],
    [() => true, 'titleStoreClosed']
  ];

  const [, translateKey] = configModalMessage.find(([shouldShowMessage]) => shouldShowMessage());

  return (
    <CustomModal
      shouldCloseOnOverlayClick={!isAccountStatusSuspended(subscriptionStatus)}
      shouldCloseOnEsc={!isAccountStatusSuspended(subscriptionStatus)}
      hideCloseButton={isAccountStatusSuspended(subscriptionStatus)}
      className={cn(styles.modal, {
        [styles.closedBySwitch]: closedByAttribute
      })}
      modal={MODALS.STORE_CLOSED}
      isOpen={open}>
      <div className="row">
        <div className={`column center full-width m-bottom-5 ${styles.closedTag}`}>
          <LottieIcon loop height={150} width={150} icon="closedRestaurant" />
          <span
            data-testid={DATA_TEST_ID.closedStoreMessage}
            className={`text-center ${styles.messageHeader}`}>
            {i18next.t(`StoreInfo:${translateKey}`)}
          </span>
        </div>
      </div>
      {!isAccountStatusSuspended(subscriptionStatus) ? (
        <Message
          onlyDeliveryAvailable={onlyDeliveryAvailable}
          onlyPickupAvailable={onlyPickupAvailable}
          closedByAttribute={closedByAttribute}
          currentDispatchMethod={currentDispatchMethod}
          continueWith={continueWith}
          businessHours={currentSubsidiary?.businessHours}
        />
      ) : null}
    </CustomModal>
  );
};

export default ClosedStoreModal;
